import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { keyframes, styled } from '@mui/material/styles';
import CommonButton from '@src/new-components/Button';
import Tooltip from '@src/components/Tooltip';
import ROUTES from '@src/constants/route';
import useTopPaidEvent from '@src/hooks/useTopPaidEvent';
import { COLOR } from '@src/styles/color';

// Fired by EventWidget once it has flown into this button.
export const EVENT_WIDGET_DOCKED = 'top-paid-event:widget-docked';
export const EVENT_HEADER_BUTTON_ATTR = 'data-event-header-button';

const bounce = keyframes`
  0%, 100% { transform: scale(1); }
  40% { transform: scale(1.2); }
  70% { transform: scale(0.95); }
`;

const StyledEventHeaderButton = styled('div', {
  shouldForwardProp: (prop) => prop !== 'bouncing',
})(({ bouncing }) => ({
  animation: bouncing ? `${bounce} 0.5s ease-in-out` : 'none',

  img: { width: 24, height: 24, objectFit: 'contain' },
}));

const BUTTON_STYLE = {
  height: '40px',
  minWidth: '40px',
  padding: '0px',
  borderRadius: '12px',
  border: `1px solid ${COLOR.indigo[16]}`,
  boxSizing: 'border-box',
};

// Header entry to the event, kept until the draw so users can follow the results after the event ends.
const EventHeaderButton = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { config, isDetailPageOpen } = useTopPaidEvent();
  const [bouncing, setBouncing] = useState(false);

  useEffect(() => {
    const handleDocked = () => setBouncing(true);
    window.addEventListener(EVENT_WIDGET_DOCKED, handleDocked);
    return () => window.removeEventListener(EVENT_WIDGET_DOCKED, handleDocked);
  }, []);

  if (!isDetailPageOpen || !config.bannerEnabled) return null;

  return (
    <Tooltip arrow title={t('topPaidEventHeaderTooltip')} placement="bottom">
      <StyledEventHeaderButton
        bouncing={bouncing}
        onAnimationEnd={() => setBouncing(false)}
        {...{ [EVENT_HEADER_BUTTON_ATTR]: true }}
      >
        <CommonButton
          variant="outlineSmall"
          customStyle={BUTTON_STYLE}
          onClick={() => history.push(ROUTES.TOP_PAID_EVENT)}
        >
          <img
            src={config.images.prizeIphone}
            alt={t('topPaidEventWidgetAlt')}
          />
        </CommonButton>
      </StyledEventHeaderButton>
    </Tooltip>
  );
};

export default EventHeaderButton;
